import { Navigate, useLocation } from "react-router-dom";

export default function LegacyPastPresidentsRosterRedirect() {
  const location = useLocation();
  return (
    <Navigate
      to={`/people/membership-services/member-elections/past-presidents${location.search}`}
      replace
      state={location.state}
    />
  );
}
